import { render, staticRenderFns } from "./CaseDetailsFullScreen.vue?vue&type=template&id=d1f3dbe8&"
import script from "./CaseDetailsFullScreen.vue?vue&type=script&lang=js&"
export * from "./CaseDetailsFullScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports